<!--
 * @Author: DY
 * @Date: 2025-02-18 17:11:52
 * @LastEditTime: 2025-02-24 14:45:14
 * @Description: 发货明细【销售管理-客户验收审批】
 * @FilePath: \ShiMo_Mobile\src\views\sales\customerAcceptanceApproval\form.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="customerAcceptanceApprovalForm commonFormStyles">
            <HeaderNav
                header-title="发货明细"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <section class="formList" :class="{'no_data': formData.length === 0}">
                <div class="list_item" v-for="(item, index) in formData" :key="index">
                    <p class="title">
                        <span>
                            <span>物料代码：{{ item.MaterialCode }}</span>
                        </span>
                    </p>
                    <div class="ps_box">
                        <div class="list_item_card">
                            <van-cell
                                title="产品卡批次号"
                                :value="item.BatchNumber"
                                :icon="require('@/assets/images/icons/icon_18@2x.png')"
                            ></van-cell>
                            <van-cell
                                title="产品卡号"
                                :value="item.ProductCardNumber"
                                :icon="require('@/assets/images/icons/icon_18@2x.png')"
                            ></van-cell>
                            <van-cell
                                title="物料代码"
                                :value="item.MaterialCode"
                                :icon="require('@/assets/images/icons/icon_46@2x.png')"
                            ></van-cell>
                            <van-cell
                                title="长描述"
                                :value="item.MaterialName"
                                :icon="require('@/assets/images/icons/icon_10@2x.png')"
                            ></van-cell>
                            <van-cell
                                title="短描述"
                                :value="item.MaterialShortName"
                                :icon="require('@/assets/images/icons/icon_28@2x.png')"
                            ></van-cell>
                            <van-cell
                                title="物料单位"
                                :value="item.MaterialUnit"
                                :icon="require('@/assets/images/icons/icon_2@2x.png')"
                            ></van-cell>
                            <van-cell
                                title="生产车间编码"
                                :value="item.ProductWorkshopCode"
                                :icon="require('@/assets/images/icons/icon_46@2x.png')"
                            ></van-cell>
                            <van-cell
                                title="生产车间名称"
                                :value="item.ProductWorkshopName"
                                :icon="require('@/assets/images/icons/icon_47@2x.png')"
                            ></van-cell>
                            <van-cell
                                title="生产日期"
                                :value="item.ProductDate"
                                :icon="require('@/assets/images/icons/icon_7@2x.png')"
                            ></van-cell>
                        </div>
                    </div>
                </div>
            </section>
            <footer class="currencyFooterStyle btns">
                <van-button type="primary" loading-type="spinner" @click="closeAllocationForm">
                    关闭
                </van-button>
            </footer>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
export default {
    // 库位表单
    name: 'customer-acceptance-approval-form',
    components: {
        HeaderNav,
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.backPathName = from.name;
        });
    },
    props: {},
    data() {
        return {
            tabActive: 0,
            isReadonly: false,
            backPathName: '',
            formData: {},
        };
    },
    computed: {},
    watch: {},
    activated() {},
    async created() {
        this.formData = await this.getformDataRequrst(this.$route.params.delivery_notice_id, this.$route.params.material_codes);
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        closeAllocationForm() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: this.backPathName,
            });
        },
        getformDataRequrst(deliveryNoticeId, materialCode) {
            return this.$axios.$get(`interfaceApi/sale/client_check/material_info?deliveryNoticeId=${deliveryNoticeId}&materialCode=${materialCode}`);
        },
    },
};
</script>
<style lang="stylus">
.customerAcceptanceApprovalForm
    background: #f0f0f0;
    .formList
        padding 10rpx
        height 0
        flex 1
        overflow-y auto
        .list_item
            margin-bottom 10rpx
            background #fff
            box-shadow: 0px 0px 3px 0px #b5b5b5;
            border-radius: 4rpx;
            position relative
            overflow hidden
            &:last-child
                margin-bottom 0
            .title
                width 100%
                height 42rpx
                background #F8F8F8
                margin-bottom 0 !important
                display flex
                align-items center
                padding 0 10rpx
                font-size 16rpx
                position relative
                display: flex;
                justify-content: space-between;
                >span
                    color: #e93743
                    display: flex;
                    justify-content: center;
                    align-items: center;
</style>
